/* Imperial Time homepage runtime — 04 Oct 2026. */
(function(){
  function initEngagementVideo(){
    var video=document.querySelector('.ithome-lower__engagement-video');
    if(!video||video.dataset.itLaunchVideo==='1')return;
    video.dataset.itLaunchVideo='1';
    video.removeAttribute('autoplay');
    video.autoplay=false;
    video.muted=true;
    video.defaultMuted=true;
    video.loop=true;
    video.playsInline=true;
    video.controls=false;
    video.preload='none';
    video.setAttribute('muted','');
    video.setAttribute('loop','');
    video.setAttribute('playsinline','');
    video.setAttribute('preload','none');
    var rate=.82,warmed=false,wants=false,pending=false,started=false;
    function setRate(){
      try{
        video.defaultPlaybackRate=rate;
        if(Math.abs(video.playbackRate-rate)>.01)video.playbackRate=rate;
      }catch(e){}
    }
    function warm(){
      if(warmed)return;
      warmed=true;
      try{
        video.preload='auto';
        video.setAttribute('preload','auto');
        video.load();
      }catch(e){}
    }
    function buffered(){
      try{
        if(!video.buffered||!video.buffered.length)return false;
        var now=video.currentTime||0,needed=3.5;
        for(var i=0;i<video.buffered.length;i++){
          if(video.buffered.start(i)<=now+.12){
            var ahead=video.buffered.end(i)-now;
            if(ahead>=needed||(video.duration&&isFinite(video.duration)&&video.duration-now<=ahead+.15))return true;
          }
        }
      }catch(e){}
      return false;
    }
    function play(){
      setRate();
      if(document.hidden||!wants)return;
      warm();
      if(!buffered()||!video.paused||pending)return;
      pending=true;
      var p=video.play();
      if(p&&typeof p.then==='function'){
        p.then(function(){pending=false;started=true;setRate();}).catch(function(){pending=false;});
      }else{pending=false;started=true;}
    }
    if('IntersectionObserver' in window){
      var near=new IntersectionObserver(function(entries){
        if(entries[0]&&entries[0].isIntersecting){warm();near.disconnect();}
      },{rootMargin:'320px 0px 320px 0px',threshold:0});
      near.observe(video);
      var view=new IntersectionObserver(function(entries){
        var entry=entries[0];
        var visible=!!(entry&&entry.isIntersecting&&entry.intersectionRatio>=.06);
        wants=visible;
        if(visible){play();}
        else if(!video.paused){try{video.pause();}catch(e){}}
      },{rootMargin:'80px 0px 80px 0px',threshold:[0,.06,.2]});
      view.observe(video);
    }else{wants=true;warm();}
    ['loadeddata','canplay','canplaythrough','progress'].forEach(function(name){
      video.addEventListener(name,function(){if(wants)play();},{passive:true});
    });
    video.addEventListener('playing',function(){started=true;pending=false;setRate();},{passive:true});
    video.addEventListener('ratechange',setRate,{passive:true});
    document.addEventListener('visibilitychange',function(){
      if(document.hidden){if(!video.paused)video.pause();}
      else if(started||wants){wants=true;play();}
    },{passive:true});
    setRate();
  }
  function boot(){initEngagementVideo();}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});
  else boot();
  document.addEventListener('shopify:section:load',function(){window.setTimeout(boot,40);});
})();